import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsPaymentLazy = loadable(() => import(/* webpackChunkName: "SettingsLight" */ './SettingsPaymentSuspense'));

export const SettingsPaymentAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsPaymentLazy />
    </DelayedSuspense>
);
